import { values } from './_helpers'

const _enum = {
  ordered: 0,
  stored: 1,
  sold: 2,
  damaged: 3,
  missing: 4
}

const storageStatus = { ..._enum, name: 'storageStatus', values: values(_enum) }

export {
  storageStatus
}
